import type {Theme, Components} from "../..";

type AvatarGroupOverrides = Components<Theme>["MuiAvatarGroup"];

const overrides: AvatarGroupOverrides = {
    styleOverrides: {
        root: {
            "& .MuiAvatar-root": {
                marginLeft: -6,
            },
        },
    },
};

export default overrides;
